const BASE_URL = process.env.REACT_APP_BASE_URL;
export const uploadPath = process.env.REACT_APP_UPLOAD_PATH;
const generateFormData = (json) => {
  const formData = new FormData();
  for (const key in json) {
    if (json.hasOwnProperty(key)) {
      const value = json[key];
      if (Array.isArray(value)) {
        value.forEach((item) => formData.append(key, item));
      } else {
        formData.append(key, value);
      }
    }
  }
  return formData;
};
const getToken = () => {
  return sessionStorage.getItem("token"); // ✅ no JSON.parse
};

const getUserId = () => {
  return sessionStorage.getItem("userId"); // ✅ no JSON.parse
};
const fetchDataWithToken = async (url, options = {}) => {
  try {
    const fullUrl = BASE_URL + url;
    console.log("Fetching:", fullUrl);

    const response = await fetch(fullUrl, {
      ...options,
      headers: {
        ...options.headers,
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });

    // Check if response is ok
    if (!response.ok) {
      const text = await response.text();
      console.error("Error response:", response.status, text);
      throw new Error(`HTTP ${response.status}: ${text}`);
    }

    // Parse JSON only if response is JSON
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    } else {
      const text = await response.text();
      console.error("Non-JSON response received:", text);
      throw new Error("Expected JSON but got non-JSON response");
    }
  } catch (error) {
    console.error("Error fetching data with token:", error);
    return null;
  }
};

// Helper function to handle requests without token (for public resources)
const fetchDataWithoutToken = async (url, options = {}) => {
  try {
    const response = await fetch(BASE_URL + url, {
      ...options,
      headers: {
        ...options.headers,
        method: "GET",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`,
      },
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching data without token:", error);
    return null;
  }
};

export const fetchData = {
  get: async (url) => {
    try {
      const fullUrl = BASE_URL + url;
      console.log("GET Request to:", fullUrl);

      const response = await fetch(fullUrl, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const text = await response.text();
        console.error(`GET ${url} failed:`, response.status, text);
        throw new Error(`HTTP ${response.status}: ${text}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error with GET request:", error);
      return null;
    }
  },

  getWithBody: async (url, body) => {
    try {
      const fullUrl = BASE_URL + url;
      console.log("GET with body Request to:", fullUrl, body);

      const response = await fetch(fullUrl, {
        method: "GET", // 👈 most APIs that require body use POST, not GET
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error in getWithBody:", error);
      throw error;
    }
  },

  // GET request without token (for public endpoints)
  getWithoutToken: async (url) => {
    try {
      return await fetchDataWithoutToken(url);
    } catch (error) {
      console.error(`Error fetching data for ${url}:`, error);
      return null;
    }
  },

  // POST request with token (for protected endpoints)
  post: async (url, data) => {
    try {
      const isFormData = data instanceof FormData;

      const response = await fetch(BASE_URL + url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          ...(isFormData ? {} : { "Content-Type": "application/json" }), // only set for JSON
        },
        body: isFormData ? data : JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("POST error", error);
      throw error;
    }
  },
  patch: async (url, data) => {
    try {
      const response = await fetch(BASE_URL + url, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with POST request:", error);
      return null;
    }
  },

  // POST request without token (for public endpoints)
  postWithoutToken: async (url, data) => {
    try {
      const response = await fetch(BASE_URL + url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with POST request:", error);
      return null;
    }
  },
  // PUT request with token (for protected endpoints)
  put: async (url, data) => {
    try {
      const response = await fetch(BASE_URL + url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with PUT request:", error);
      return null;
    }
  },

  patch: async (url, data) => {
    try {
      const response = await fetch(BASE_URL + url, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with PATCH request:", error);
      return null;
    }
  },

  // PUT request without token (for public endpoints)
  putWithoutToken: async (url, data) => {
    try {
      const response = await fetch(BASE_URL + url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with PUT request:", error);
      return null;
    }
  },

  // DELETE request with token (for protected endpoints)
  delete: async (url, body) => {
    try {
      console.log(BASE_URL);

      const response = await fetch(BASE_URL + url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      return await response.json();
    } catch (error) {
      console.error("Error with DELETE request:", error);
      return null;
    }
  },

  // DELETE request without token (for public endpoints)
  deleteWithoutToken: async (url) => {
    try {
      const response = await fetch(BASE_URL + url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      return await response.json();
    } catch (error) {
      console.error("Error with DELETE request:", error);
      return null;
    }
  },

  // POST request with FormData (used for uploading files)
  postWithFormData: async (url, formData) => {
    // 🔍 Log FormData content
    console.log("🧾 FormData content:");
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}: [File] ${value.name}`);
      } else {
        console.log(`${key}: ${value}`);
      }
    }

    // 👇 Log headers being sent
    const headers = {
      Authorization: `Bearer ${getToken()}`,
    };

    console.log("📦 Request headers:", headers);

    try {
      const response = await fetch(BASE_URL + url, {
        method: "POST",
        headers, // only Authorization — DO NOT add Content-Type
        body: formData,
      });

      console.log("📥 Raw response object:", response);

      const result = await response.json();
      console.log("✅ JSON Response:", result);
      return result;
    } catch (error) {
      console.error("❌ Error with FormData POST:", error);
      return null;
    }
  },
  putWithFormData: async (url, formData) => {
    try {
      const response = await fetch(BASE_URL + url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: generateFormData(formData),
      });
      return await response.json();
    } catch (error) {
      console.error("Error with FormData POST:", error);
      return null;
    }
  },

  // POST request without FormData (public)
  postWithoutFormData: async (url, data) => {
    try {
      const response = await fetch(BASE_URL + url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      console.error("Error with POST request:", error);
      return null;
    }
  },
};

// Example API service methods that use fetchData
export const api = {
  signInSuperAdmin: async (body = {}) => {
    console.log("Request body:", body);
    const data = await fetchData.post(`/admin/login`, body);
    console.log("Response from /admin/login:", data);
    return data ? data : {};
  },

  getOfferBanner: async () => {
    const data = await fetchData.get(`/banners`);
    return data ? data.result?.data || [] : [];
  },
  getSolorInfoBanner: async () => {
    const data = await fetchData.get(`/solarInfo-banner`);
    return data ? data.result?.data || [] : [];
  },
  removeOfferBanner: (data) => {
    return fetchData.delete("/remove-offer-banner?banner_id=" + data);
  },
  removeSolarInfoBanner: (data) => {
    return fetchData.delete("/remove-solar-info?banner_id=" + data);
  },
  getElectricityProviders: async () => {
    const data = await fetchData.get(`/electricity-providers-admin`);
    console.log(data.result);

    return data;
  },
  approveLoanDetails: async (payload) => {
    return await fetchData.post("/approve-loan-details", payload);
  },
  getElectricityProviderByCode: async (code) => {
    const data = await fetchData.get(
      `/electricity-providers/by-code?code=${code}`
    );
    return data?.result || null;
  },

  removeElectricityProvider: (data) => {
    return fetchData.delete("/remove-electricity-providers?code=" + data);
  },
  getAllCustomers: async () => {
    const data = await fetchData.get("/customers-list");
    return data?.result || [];
  },
  getAllLoanCustomers: async () => {
    const data = await fetchData.post("/get-loan-customer-list");
    return data?.result || [];
  },
  getAllSalesExecutives: async () => {
    const data = await fetchData.get("/user/get-all-SalesExecutives");
    return data?.result || [];
  },
  getAllInventoryManager: async () => {
    const data = await fetchData.get("/user/get-all-InventoryManager");
    return data?.result || [];
  },
  getAllfileManager: async () => {
    const data = await fetchData.get("/user/get-all-FileManager");
    return data?.result || [];
  },

  getAlOnsiteExecutive: async () => {
    const data = await fetchData.get("/user/get-all-OnsiteExecutive");
    return data?.result || [];
  },
  getUserByPhone: async (phone) => {
    const data = await fetchData.get(`/user/by-phone-number/${phone}`);
    return data;
  },
  removeUserRole: async (payload) => {
    return await fetchData.post("/user/delete-user-role", payload);
  },
};
